import React from "react";
import { TableContentForCustomerLeafCollectionReport } from '../../../Common/Table/tableContent';
import tokenService from "../../../../Common/tokenDecoder";

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const reportData = this.props.data;
        const contentRowNames = this.props.rowNames;
        const totalAmount = this.props.totalAmount;
        const customerCount = this.props.customerCount;
        const totalAmountOfLeaf = this.props.totalAmountOfLeaf;
        const bagCount = this.props.bagCount;
        const totalBagCount = this.props.totalBagCount;
        const totalValues = this.props.totalValues;

        return (
            <div>
                <h3><center><u>Customer Leaf Collection Report - RTF</u></center></h3>
                <div className="row pb-4 pt-4 pl-2">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Estate: </b> {searchData.factory}</div>
                    <div className="col"><b>Route: </b>
                        {searchData.route === undefined ? "All Routes" : searchData.route}</div>
                    <div className="col"><b>Collection Types: </b>
                        {searchData.collectionType === undefined ? "All Collection Types" : searchData.collectionType} </div>
                    <div className="col"><b>Date: </b> {searchData.date}</div>
                </div>
                <div className="row pb-4 pt-4 pl-2">
                    <div className="col"><b>Date: </b> {new Date().toLocaleString()}</div>
                    <div className="col"><b>User: </b> {tokenService.getUserNameFromToken()}</div>
                </div>

                <div className="card pt-2 pl-3 pr-4" style={{ width: "10rem;" }}>
                    <div className="card-header"><h6>Summary</h6></div>
                    <div className="card-body">
                        <p className="d-inline pr-3"><b>Customer count : </b> {customerCount} </p>
                        {totalAmount.map((d, i) => {
                            return (
                                <p key={i} className="pt-3 d-inline pr-3"><b>{d.collectionTypeName} : </b>{(d.totalAmount)} Kg</p>
                            )
                        })}
                        <p className="d-inline pr-3"><b>Total Leaf Amount: </b> {totalAmountOfLeaf} Kg</p>
                        {bagCount.map((d, i) => {
                            return (
                                <p key={i} className="pt-3 d-inline pr-3"><b>{d.collectionTypeName} : </b>{(d.numberOfUnits)} bags</p>
                            )
                        })}
                        <p className="d-inline pr-3"><b>Total Bag Count: </b> {totalBagCount} bags</p>
                    </div>
                </div>

                <div>
                    <table id="example" className="display dataTable no-footer">
                        <thead>
                            <tr>
                                <th>Leaf collected date</th>
                                <th>Route name</th>
                                <th>Customer reg. number</th>
                                <th>Custome Name</th>
                                <th>Collection type</th>
                                <th>Bag count</th>
                                <th>Gross total (Kg)</th>
                                <th>Total Deduction(Kg)</th>
                                {/* <th>Return Total (Kg)</th> */}
                                <th>Net total (Kg)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <TableContentForCustomerLeafCollectionReport
                                data={reportData}
                                contentRowNames={contentRowNames}
                                hasEdit={false}
                            />
                        </tbody>
                        <tfoot>
                            <tr>
                                <th colSpan="5" style={{ textAlign: "left" }}> Total </th>
                                <th style={{ textAlign: "right" }}>{totalValues.bagcount}</th>
                                <th style={{ textAlign: "right" }}>{totalValues.gross.toFixed(2)}</th>
                                <th style={{ textAlign: "right" }}>{totalValues.deduction.toFixed(2)}</th>
                                {/* <th style={{ textAlign: "right" }}>{totalValues.return.toFixed(2)}</th> */}
                                <th style={{ textAlign: "right" }}>{totalValues.net.toFixed(2)}</th>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        );
    }
}